
import { LoadingBarApi, useLoadingBar } from 'naive-ui';
import { defineComponent, watchEffect } from 'vue';
import { loadingInstances, isLoading } from '@/utils/loading';

export default defineComponent({
  setup() {
    const loadingBar: LoadingBarApi = useLoadingBar();
    watchEffect(() => {
      if (loadingInstances.value > 0) {
        if (!isLoading.value) {
          loadingBar.start();
          isLoading.value = true;
        }
      } else {
        isLoading.value = false;
        loadingBar.finish();
      }
    });
  }
})
